export default function ProcessLabel() {
  return (
    <div className="flex flex-col gap-y-[8px] lg:gap-y-[14px]">
      <div className="flex text-label2 lg:text-body1 items-center gap-x-[12px] text-label-300">
        <div className="w-[12px] h-[12px] lg:w-[20px] lg:h-[20px] rounded-[50px] bg-[#C6C6C6]"/>
        기존 프로세스 (5단계)
      </div>
      <div
        className="flex text-label2 lg:text-body1 items-center gap-x-[8px] lg:gap-x-[12px] text-primary-400">
        <div className="w-[12px] h-[12px] lg:w-[20px] lg:h-[20px] rounded-[50px] bg-primary-100"/>
        모듈링크의 개선 프로세스 (4단계로 단축)
      </div>
    </div>
  )
}